<template>
<v-toolbar dense flat :dark='dark' class='pa-0 ma-0 nopadd' >
  <template v-if='colleagueIds && colleagueIds.length > 1' >
    <v-list v-if='$vuetify.breakpoint.xs' dark class='pt-0 mb-0 pl-2' >
      <v-list-tile @click='mobileSelectCalendar=true' >
        <v-list-tile-avatar class="white--text" color='teal' >
          <v-img v-if='getProfilePicture(selected)' :src='getProfilePicture(selected)' />
          <span v-else>{{ initials(selected) }}</span>
        </v-list-tile-avatar >
        <v-list-tile-content>
          <v-list-tile-title v-text="selectedFullName" />
        </v-list-tile-content>
        <v-list-tile-action >
          <v-btn icon ><v-icon >expand_more</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-bottom-sheet v-model='mobileSelectCalendar' :persistent='false' inset >
        <v-card>
          <v-card-title class='overline grey lighten-4 py-2' >
            Pick a calendar
            <v-spacer/>
            <v-btn @click='mobileSelectCalendar=false' small icon ><v-icon small>close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-list>
            <v-list-tile
              v-for='colleague in colleagues' :key='colleague.id'
              @click='setSelected(colleague);mobileSelectCalendar=false' >
              <v-list-tile-avatar class="white--text" color='teal' >
                <v-img v-if='getProfilePicture(colleague)' :src='getProfilePicture(colleague)' />
                <span v-else>{{ initials(colleague) }}</span>
              </v-list-tile-avatar >
              <v-list-tile-content>
                <v-list-tile-title v-text='colleague.full_name' />
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-bottom-sheet>
    </v-list>
    <v-tabs v-else v-model='activeTab' >
      <v-tab @click="setSelected(me)" >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              v-on='on' v-bind="attrs"
              size=24 class="mr-2" >
              <v-img v-if='profilePicture' :src='profilePicture' />
              <span v-else >{{ initials(me) }}</span>
            </v-avatar>
          </template>
          <strong>it's you!</strong>
          <div v-for='mem in myMemberships' >
            {{mem.role}} @ {{mem.title}}
          </div>
        </v-tooltip>
        <v-badge class='ctabs' bordered overlap small right >
          <template v-slot:badge>+</template>
          <v-btn icon small outline
            @click.prevent='newAppointment(me)' >
            <v-icon small>event</v-icon>
          </v-btn>
        </v-badge>
      </v-tab>
      <template v-for='colleague in colleagues' >
        <v-divider vertical :key='`div-${colleague.id}`' />
          <v-tab outlined
            :key='colleague.id'
            v-if='colleague.id !== me.id'
            @click='setSelected(colleague)' >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    v-on='on' v-bind="attrs"
                    size=24 class="mr-2 white--text" color='teal' >
                    <v-img v-if='getProfilePicture(colleague)' :src='getProfilePicture(colleague)' />
                    <span v-else>{{ initials(colleague) }}</span>
                  </v-avatar>
                </template>
                <span >
                  <strong>{{ colleague.full_name }}</strong>
                  <div v-for='mem in colleague.memberships' >
                    {{mem.role}} @ {{mem.space_name}}
                  </div>
                </span>
              </v-tooltip>
            <!-- <v-btn icon small outline
              @click.prevent='newAppointment(colleague)' >
              <v-icon small>add</v-icon>
            </v-btn> -->
            <v-badge class='ctabs' bordered overlap small right >
              <template v-slot:badge>+</template>
              <v-btn icon small outline
                @click.prevent='newAppointment(colleague)' >
                <v-icon small>event</v-icon>
              </v-btn>
            </v-badge>
          </v-tab>
      </template>
      <invite-btn text='Invite' icon='add' :attrs="{flat:true}" ></invite-btn>
      <v-spacer></v-spacer>
      <!-- <v-text-field placeholder='search' append-icon='search' v-model='searchString' /> -->
      <v-progress-circular
        v-if='loading'
        indeterminate color='amber' class='ma-2' width='2' >
      </v-progress-circular>
      <!-- <v-btn small outline class='mt-2' >Side by side</v-btn> -->
      <template v-if='facets && facets.spaces' >
        <v-chip
          class='v-chip--x-small mt-2' outline color='primary'
          style='margin-top:12px!important;'
          v-for='id in Object.keys(facets.spaces)' :key='id'
          @click='setSelectedSpace(id)' >
          <v-icon v-if='selectedSpace===id' class='ma-0' small>check</v-icon>
          {{ facets.spaces[id].title}}
        </v-chip>
      </template>
      <v-btn to='/calendar/team' outline small >Team View</v-btn>
    </v-tabs>
  </template>
  <!-- <v-spacer></v-spacer> -->
  <!-- {{facets}} -->
</v-toolbar>
</template>
<script>
import {SET_SETTING} from '@/store/constants'
import InviteBtn from '@/components/btns/InviteBtn.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'CalendarTabs',
  components: {InviteBtn},
  props: {
    value: { type: Object },
    facets: { type: Object },
    loading: { type: Boolean, default: false },
    dark: { type: Boolean, default: false }
  },
  data () {
    return {
      activeTab: 0,
      searchString: '',
      selected: null,
      selectedSpace: null,
      mobileSelectCalendar: false
    }
  },
  computed: {
    ...mapGetters(['me', 'meId', 'getSpacesByPractitionerId']),
    myMemberships () {
      return this.getSpacesByPractitionerId(this.meId)
    },
    colleagues () {
      return this.$store.getters.getColleagues
    },
    colleagueIds () {
      if (this.colleagues) {
        return Object.keys(this.colleagues)
      }
      return []
    },
    profilePicture () {
      return this.getProfilePicture(this.me)
    },
    selectedProfilePicture () {
      return this.getProfilePicture(this.selected)
    },
    selectedFullName () {
      let fn = this.getObjectPath(this.selected, 'full_name')
      if (!fn) {
        fn = this.formatFullName(this.selected)
      }
      return fn
    }
  },
  watch: {
    selectedSpace () {
      this.$emit('space', this.selectedSpace)
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.selected = this.value }
      }
    }
  },
  methods: {
    setSelected (practitioner) {
      this.selected = practitioner
      this.$emit('input', practitioner)
    },
    setSelectedSpace (id) {
      if (this.selectedSpace === id) {
        this.selectedSpace = null
      } else {
        this.selectedSpace = id
      }
    },
    newAppointment (practitioner) {
      if (practitioner) {
        this.setSelected(practitioner)
      }
      let vm = this
      if (this.selected && this.selected.id) {
        console.log('active practitioner', this.selected.id)
        window.setTimeout(() => {
          vm.$store.commit(SET_SETTING, ['activePractitioner', this.selected])
        }, 100)
      }
      this.openGlobalDialog(true, 'QuickCreate')
    }
  }
}
</script>
<style>
.v-toolbar.nopadd .v-toolbar__content { padding: 0px !important; }
.ctabs.v-badge--overlap .v-badge__badge {
    top: -2px;
    right: 0px;
    height: 18px;
    width: 18px;
}
</style>



// WEBPACK FOOTER //
// CalendarTabs.vue?55cb93b1